// Generated by CoffeeScript 1.12.7
(function () {
  var LabelService, defaultLabelFields;

  defaultLabelFields = require("./DefaultLabelFields")["default"];

  module.exports = LabelService = (function () {
    function LabelService(accountQuoteSettings, uniqueId, $timeout) {
      var getLabelSets;
      if ($timeout == null) {
        $timeout = function () {};
      }
      getLabelSets = function () {
        return accountQuoteSettings.labels;
      };
      this.getDefaultFields = function () {
        return _.clone(defaultLabelFields);
      };
      this.getActiveLabelSets = function () {
        var allLabelSets;
        allLabelSets = getLabelSets();
        return _.filter(allLabelSets, {
          isActive: true,
        });
      };
      this.getLabelSet = function (id) {
        var allLabelSets, labelSet;
        if (id == null) {
          return {
            name: "Default Labels",
            labels: _.clone(defaultLabelFields),
          };
        }
        allLabelSets = getLabelSets();
        labelSet = _.find(allLabelSets, {
          id: id,
        });
        if (labelSet == null) {
          return {
            name: "Default Labels",
            labels: _.clone(defaultLabelFields),
          };
        }
        return _.cloneDeep(labelSet);
      };
      this.getLabel = function (id, field) {
        var labelSet, ref;
        if (field == null) {
          throw new Error("No label field given");
        }
        if (defaultLabelFields[field] == null) {
          throw new Error("Not a valid label field");
        }
        labelSet = this.getLabelSet(id);
        if (((ref = labelSet.labels[field]) != null ? ref.length : void 0) > 0) {
          return labelSet.labels[field];
        } else {
          return defaultLabelFields[field];
        }
      };
      this.updateLabelSet = function (id, name, labels) {
        var allLabelSets, labelSetIndex;
        if (id == null) {
          throw new Error("No id given for label set");
        }
        if (!(name != null ? name.length : void 0) > 0) {
          throw new Error("No name given for label set");
        }
        if (labels == null || _.keys(labels).length === 0) {
          throw new Error("No labels given to update");
        }
        allLabelSets = getLabelSets();
        labelSetIndex = _.findIndex(allLabelSets, {
          id: id,
        });
        if (labelSetIndex < 0) {
          labelSetIndex = allLabelSets.length;
          allLabelSets.push({
            id: id,
            isActive: true,
          });
        }
        allLabelSets[labelSetIndex].name = name;
        allLabelSets[labelSetIndex].labels = labels;
        return $timeout(function () {});
      };
      this.createLabelSet = function () {
        var field, newLabelSet, newLabels;
        newLabels = _.clone(defaultLabelFields);
        for (field in newLabels) {
          newLabels[field] = "";
        }
        newLabelSet = {
          name: "New Label Set",
          id: uniqueId(),
          labels: newLabels,
          isActive: true,
        };
        return newLabelSet;
      };
      this.deleteLabelSet = function (id) {
        var toDeleteIndex;
        if (id == null) {
          throw new Error("No id given for label set");
        }
        toDeleteIndex = _.findIndex(accountQuoteSettings.labels, {
          id: id,
        });
        if (toDeleteIndex < 0) {
          throw new Error("Could not find label set to delete");
        }
        return accountQuoteSettings.labels.splice(toDeleteIndex, 1);
      };
    }

    return LabelService;
  })();
}.call(this));
